import SecureLS from 'secure-ls';

export interface AccessToken {
    token: string,
    expires: Date,
    uid: string,
    cid: string
}

class AccessTokenModel {
    private static ACCESS_TOKEN_KEY = 'atkn';
    private _accessToken: AccessToken | null = null;
    private secureLs: SecureLS = new SecureLS({
        encodingType: 'aes',
    })

    public get token(): AccessToken {
        if (!this._accessToken) {
            const jsonAccessToken = this.secureLs.get(AccessTokenModel.ACCESS_TOKEN_KEY);

            if (!jsonAccessToken) throw new Error("Not logged in");

            try {
                this._accessToken = JSON.parse(jsonAccessToken);
                if (!this._accessToken) {
                    throw new Error("Not logged in");
                }
            } catch (e) {
                this.secureLs.remove(AccessTokenModel.ACCESS_TOKEN_KEY);
                throw new Error("Not logged in");
            }
        }

        return this._accessToken!;
    }

    public updateToken(token: any) {
        if (!token) {
            throw new Error("Empty token");
        }
        if (!token.tkn || !token.exp || !token.uid || !token.cid) {
            throw new Error("Invalid token token model");
        }

        this._accessToken = {
            token: token.tkn,
            expires: new Date(token.exp),
            uid: token.uid,
            cid: token.cid
        }

        this.secureLs.set(AccessTokenModel.ACCESS_TOKEN_KEY, JSON.stringify(this._accessToken));

        return this._accessToken;
    }

    public removeToken() {
        this.secureLs.remove(AccessTokenModel.ACCESS_TOKEN_KEY);
    }

    public isVerified(): boolean {
        return true;
    }
}


export const accessTokenModel = new AccessTokenModel();